// Angular
import { Directive, ElementRef, Output, EventEmitter, HostListener, Input } from '@angular/core';

@Directive({
	selector: '[clickOutside]',
})
export class ClickOutsideDirective {
	@Input() excludeClasses: string[];
	@Input() clickOutsideActive: boolean;
	@Input() delayClickOutside: number = 0;
	@Output() clickOutside = new EventEmitter();

	constructor(private _elementRef: ElementRef) {}

	@HostListener('document:click', ['$event'])
	onClick(event: MouseEvent) {
		const targetElement = event.target as HTMLElement;

		if (!this.clickOutsideActive) {
			return;
		}

		if (!this._elementRef.nativeElement.contains(targetElement)) {
			// Check if the clicked element or any of its parents has an exclude class
			if (!this.isExcluded(targetElement)) {
				this.clickOutside.emit();
			}
		}
	}

	private isExcluded(element: HTMLElement): boolean {
		if (!this.excludeClasses || this.excludeClasses?.length === 0) {
			return false;
		}

		let currentElement: HTMLElement | null = element;

		// Traverse the DOM tree to check for any exclude class on the clicked element or its parents
		while (currentElement) {
			if (this.excludeClasses.some((cls) => currentElement?.classList.contains(cls))) {
				return true; // Found an exclude class
			}
			currentElement = currentElement.parentElement; // Move to the parent
		}

		return false; // No exclude class found in the hierarchy
	}
}
